// extracted by mini-css-extract-plugin
module.exports = {"container":"Uploader_container__2lDvj","title":"Uploader_title__2K4_z","subtitle":"Uploader_subtitle__lVNmp","uploader":"Uploader_uploader__2dv4P"};